import { useEffect } from 'react';

/**
 * Keyboard avoidance on iOS, which is the one genuinely hard piece of mobile
 * layout in this app.
 *
 * Safari does not resize the layout viewport when the keyboard opens — only the
 * visual viewport — so a `position: fixed` composer ends up behind the keyboard.
 * The fix is to stop using fixed positioning and drive the shell's height from
 * `visualViewport.height` instead, then pin the layout viewport back to the top
 * after every one of Safari's pans.
 */
export function useVisualViewport(): void {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const sync = (): void => {
      document.documentElement.style.setProperty('--app-h', `${String(viewport.height)}px`);
      // iOS pans the layout viewport when the keyboard opens and does not
      // always put it back; without this the header drifts off the top.
      window.scrollTo(0, 0);
    };

    viewport.addEventListener('resize', sync);
    viewport.addEventListener('scroll', sync);
    sync();

    return () => {
      viewport.removeEventListener('resize', sync);
      viewport.removeEventListener('scroll', sync);
      document.documentElement.style.removeProperty('--app-h');
    };
  }, []);
}
